import { render, staticRenderFns } from "./SettingTemplate.vue?vue&type=template&id=2d310356&"
import script from "./SettingTemplate.vue?vue&type=script&lang=ts&"
export * from "./SettingTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SettingTemplate.vue?vue&type=style&index=0&id=2d310356&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports